
import { SaleLayoutFreeLine } from "@/utils/sale-layouts/free-line";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
import AppLogo from "@/components/layout-editor/Logo.vue";
import AppFreeBlock from "./FreeBlock.vue";

export default Vue.extend({
	props: {
		line: {
			type: Object as ()=>SaleLayoutFreeLine,
			required: true
		},
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		lang: {
			type: String,
			required: true
		}
	},
	components: {
		AppLogo,
		AppFreeBlock
	}
});
